/*
 * @Author: ghy
 * @Date: 2023-07-17 12:51:36
 * @LastEditors: ghy
 * @LastEditTime: 2023-07-28 14:23:49
 * @Description: 
 */
import Vue from 'vue'
import Router from 'vue-router'
import homeHage from '@/views/homeHage'
import login from '@/views/login'

import systemList from '@/views/system/index'
import noticeList from '@/views/notice/noticeList'
import noticeDetails from '@/views/notice/noticeDetails'
import caseList from '@/views/case/caseList'
import caseDetails from "@/views/case/caseDetails"
import policyList from '@/views/policy/policyList'
import policyDetails from "@/views/policy/policyDetails"
import equipList from '@/views/equip/equipList'
import equipDetails from '@/views/equip/equipDetails'

import searchList from '@/views/search/searchList'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'homeHage',
      component: homeHage
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    
    {
      //办学系统
      path: '/systemList',
      name: 'systemList',
      component: systemList
    },
    {
      //通知公告
      path: '/noticeList',
      name: 'noticeList',
      component: noticeList
    },
    {
      //案例展示
      path: '/noticeDetails',
      name: 'noticeDetails',
      component: noticeDetails
    },
    {
      //案例展示
      path: '/caseList',
      name: 'caseList',
      component: caseList
    },
    {
      //案例展示
      path: '/caseDetails',
      name: 'caseDetails',
      component: caseDetails
    },
    {
      //政策文件
      path: '/policyList',
      name: 'policyList',
      component: policyList
    },
    {
      //政策文件
      path: '/policyDetails',
      name: 'policyDetails',
      component: policyDetails
    },
    
    {
      //仪器样例
      path: '/equipList',
      name: 'equipList',
      component: equipList
    },
    {
      //仪器样例详情
      path: '/equipDetails',
      name: 'equipDetails',
      component: equipDetails
    },
    
    {
      //搜索
      path: '/searchList',
      name: 'searchList',
      component: searchList
    },
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js